import { styled } from '@mui/material';

const CircleContainer = styled('div', { target: 'circle-container' })<{
  size: 45 | 42 | 40 | 32;
  light?: boolean;
}>(({ size, light, theme: { palette } }) => ({
  flex: `0 0 ${size}px`,
  display: 'inline-flex',
  justifyContent: 'center',
  backgroundColor: palette.success.light,
  color: 'white',
  borderRadius: 100,
  alignItems: 'center',
  width: size,
  height: size,
  overflow: 'hidden',
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 22,
  letterSpacing: '0.05em',
  textAlign: 'center',
  ...(light && {
    backgroundColor: palette.common.grey45,
    color: palette.common.black,
    opacity: 0.5,
  }),
}));

export default CircleContainer;
